import React, { useState, useEffect } from 'react';
import StackedContent from "@components/StackedContent/StackedContent";
import { useTasklist } from '@/context/TasklistContext';
import Button from '@components/Button/Button';
import { CheckIcon } from '@/components/MenusIcons/MenusIcons';

interface StatusMarkerProps {
  checklistId: number;
  accountId: number;
}

const StatusMarker: React.FC<StatusMarkerProps> = ({
  checklistId,
  accountId,
}) => {
  const { tasklistTopicStatus, markTasklistTopicRead } = useTasklist();
  const [isLoading, setIsLoading] = useState(false);

  // Dynamically get status from context
  const isCompleted = (tasklistTopicStatus ?? []).some(
    (item) =>
      Number(item.checklistId) === Number(checklistId) &&
      Number(item.accountId) === Number(accountId) &&
      item.status === 'true'
  );

  const handleToggleStatus = async () => {
    const newStatus = isCompleted ? 'false' : 'true';

    try {
      setIsLoading(true);
      await markTasklistTopicRead(accountId, checklistId, newStatus);
    } catch (error) {
      console.error('Error updating checklist status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const qsi = (window as any).QSI;

    if (isCompleted) {
      const interval = setInterval(() => {
        if (qsi?.API) {
          console.log('QSI found. Reloading intercept...');
          qsi.API.unload();
          qsi.API.load().then(qsi.API.run);
          clearInterval(interval);
        } else {
          console.log('Waiting for QSI...');
        }
      }, 500);

      return () => clearInterval(interval);
    } else if (qsi?.API) {
      console.log('Checklist marked incomplete. Unloading QSI.');
      qsi.API.unload(); // hide the widget if checklist is marked incomplete
    }
}, [isCompleted]);


  return (
    <StackedContent>
      <StackedContent.Col1 cols="10">
        <div className="status-marker">
          {isCompleted ? (
            <>
              <p className="status-title">You've completed this task! 🎉</p>
              <Button
                onClick={handleToggleStatus}
                disabled={isLoading}
                label={isLoading ? 'Updating...' : 'Mark as Incomplete'}
                variant="border"
                size="lg"
                width="fit-content"
                color="primary"
                className="underline hover:text-blue-800 self-start"
              />
            </>
          ) : (
            <>
              <p className="status-title">Ready to Continue?</p>
              <Button
                onClick={handleToggleStatus}
                disabled={isLoading}
                label={isLoading ? 'Updating...' : 'Mark as Read'}
                icon={<CheckIcon />}
                iconPosition="before"
                size="lg"
                variant="fill"
                width="fit-content"
                color="primary"
                breakpoint="all"
                className="primary"
              />
            </>
          )}
        </div>
      </StackedContent.Col1>
      <StackedContent.Col2 cols="10">
      {isCompleted && (
        <div className='checklist-qualtrics-container'>
            {/* Qualtrics widget will appear here when checklist is marked as complete */}     
        </div>
      )}
      </StackedContent.Col2>
    </StackedContent>
  );
};

export default StatusMarker;